export interface StoreHours {
  id: number;
  day_of_week: number;
  day_name: string;
  open_time: string | null;
  close_time: string | null;
  is_closed: boolean;
}

export interface StoreSpecialHours {
  id: number;
  date: string;
  open_time: string | null;
  close_time: string | null;
  is_closed: boolean;
  note: string;
}

export interface StoreStatus {
  status: 'Open' | 'Closed' | 'Closing Soon' | 'Unknown';
  note: string | null;
}

export interface Store {
  id: number;
  name: string;
  address_line1: string;
  address_line2?: string | null;
  city?: string | null;
  state?: string | null;
  postal_code?: string | null;
  country?: string | null;
  phone_number?: string | null;
  website?: string | null;
  latitude?: number | null;
  longitude?: number | null;
  google_place_id?: string | null;
  image_url?: string | null;
  thumbnail_url?: string | null;
  icon_url?: string | null;
  image_attribution?: string | null;
  regular_hours?: StoreHours[];
  special_hours?: StoreSpecialHours[];
  store_status?: StoreStatus;
  created_at?: string;
  updated_at?: string;
  active?: boolean;
  deleted?: boolean;
}

export interface StoreFormData {
  name: string;
  address_line1: string;
  address_line2: string;
  city: string;
  state: string;
  postal_code: string;
  country: string;
  phone_number: string;
  website: string;
  latitude: string;
  longitude: string;
  google_place_id: string;
  image_url: string;
  thumbnail_url: string;
  icon_url: string;
  image_attribution: string;
}

export const emptyStoreFormData: StoreFormData = {
  name: '',
  address_line1: '',
  address_line2: '',
  city: '',
  state: '',
  postal_code: '',
  country: '',
  phone_number: '',
  website: '',
  latitude: '',
  longitude: '',
  google_place_id: '',
  image_url: '',
  thumbnail_url: '',
  icon_url: '',
  image_attribution: '',
};

export interface PlaceSearchResult {
  place_id: string;
  name: string;
  address: string;
  lat: number;
  lng: number;
}

export interface PlacePhoto {
  reference: string;
  width: number;
  height: number;
  attributions: string[];
}

export interface PlaceDetails {
  place_id: string;
  name: string;
  address_line1: string;
  city: string | null;
  state: string | null;
  postal_code: string | null;
  country: string | null;
  phone_number: string | null;
  website: string | null;
  latitude: number;
  longitude: number;
  opening_hours_text: string[] | null;
  opening_hours_periods: Array<{
    day: number;
    open_time: string;
    close_time: string | null;
  }>;
  photo_references: PlacePhoto[];
}

export interface StoreImage {
  id: number;
  image_url: string;
  thumbnail_url: string;
  icon_url: string;
  attribution: string | null;
}